import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import AddProductDialog, { CatalogProduct } from "./AddProductDialog.tsx";
import LinkHandler from "./LinkHandler.tsx";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";
import AttributePicker from "../Common/AttributePicker.tsx";

const SingleProduct: React.FC<any> = (data) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [body, setBody] = useState<string>("");
  const [footer, setFooter] = useState<string>("");
  const [saveAs, setSaveAs] = useState<string>("");
  const [catalogId, setCatalogId] = useState<string>("");
  const [selectedProduct, setSelectedProduct] = useState<CatalogProduct | null>(null);
  const { nodes, setNodes, businessId } = useFlowStore();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    const node = nodes.find((n) => n.data.id === data.nodeId);
    if (!node) return;
    const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
    if (!content?.data) return;
    const d = content.data as Record<string, unknown>;
    setBody((d.body as string) || "");
    setFooter((d.footer as string) || "");
    setSaveAs((d.saveAs as string) || "");
    setCatalogId((d.catalogId as string) || "");
    if (d.product) setSelectedProduct(d.product as CatalogProduct);
    initialized.current = true;
  }, [nodes, data.nodeId, data.subNodeId]);

  useEffect(() => {
    if (!initialized.current) return;
    const updatedNodes = nodes.map((node) => {
      if (node.data.id !== data.nodeId) return node;
      return {
        ...node,
        data: {
          ...node.data,
          content: (node.data as CanvasNodeData).content.map((nodeContent) => {
            if (nodeContent.id !== data.subNodeId) return nodeContent;
            return {
              ...nodeContent,
              data: {
                body,
                footer,
                saveAs,
                catalogId,
                productRetailerId: selectedProduct?.retailerId || "",
                product: selectedProduct,
              },
            };
          }),
        },
      };
    });
    setNodes([...(updatedNodes as CanvasNode[])]);
  }, [body, footer, saveAs, selectedProduct, catalogId]);

  const handleProductSelect = (product: CatalogProduct, selectedCatalogId: string) => {
    setSelectedProduct(product);
    setCatalogId(selectedCatalogId);
    setVisible(false);
  };

  return (
    <>
      <div className="node-body">
        <div
          className="flex flex-col items-center justify-center w-[100%] h-[120px]"
          style={{ backgroundColor: "white" }}
          onClick={() => setVisible(true)}
        >
          {selectedProduct?.imageUrl ? (
            <img
              src={selectedProduct.imageUrl}
              alt={selectedProduct.productName}
              style={{ width: 40, height: 40, borderRadius: 6, objectFit: "cover", marginBottom: 4 }}
            />
          ) : (
            <img src={require("../../assets/sidepanel/cart.png")} width={20} alt="" />
          )}
          <span className="font-label" style={{ textAlign: "center", padding: "0 8px" }}>
            {selectedProduct ? selectedProduct.productName : "+ Add Product"}
          </span>
          {selectedProduct && (
            <span style={{ fontSize: "10px", color: "#64748b" }}>SKU: {selectedProduct.retailerId}</span>
          )}
        </div>
        <input
          type="text"
          placeholder="Body"
          value={body}
          onChange={(event) => setBody(event.target.value)}
          style={{ marginBottom: "0px" }}
        />
        <input
          type="text"
          value={footer}
          onChange={(event) => setFooter(event.target.value)}
          placeholder="Footer"
        />
        <div style={{ marginTop: "6px" }}>
          <span className="font-label">Save selection as</span>
          <AttributePicker
            value={saveAs}
            onChange={setSaveAs}
            placeholder="— Save to attribute (optional) —"
            defaultType="OBJECT"
          />
        </div>

        <LinkHandler />
      </div>
      <Dialog
        header="Select Product"
        visible={visible}
        modal
        appendTo={document.body}
        maskStyle={{
          background: "rgba(0,0,0,0.6)",
          zIndex: 9998,
        }}
        contentStyle={{ zIndex: 9999 }}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
      >
        <AddProductDialog
          businessId={businessId}
          selectedRetailerId={selectedProduct?.retailerId}
          onSelect={handleProductSelect}
        />
      </Dialog>
    </>
  );
};

export default SingleProduct;
